import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Panel from '../../../../UniformComponents/Panel'
import PanelHeader from '../../../../UniformComponents/PanelHeader'
import Button from '../../../../UniformComponents/Button'
import Switch from '../../../../UniformComponents/Switch'
import Select from '../../../form/Select'
import Badge from '../../../../UniformComponents/Badge'
import ComparisonModal from './ComparisonModal'

@observer
class ReportHeader extends Component {
    render() {
        const { store, reportStore } = this.props
        const { showComparison } = reportStore
        const { survey } = store
        const isMaxbiReport = survey.isMaxbi()

        const cssClass = showComparison ? 'withComparison' : ''

        return (
            <Panel cssClass={`reportHeader ${cssClass}`} style={{ overflow: 'unset' }}>
                <PanelHeader>
                    <div style={{ position: 'relative' }}>
                        <span>{survey.title}</span>
                        <div>
                            <div className="expandAll">
                                <Switch
                                    label={i18n.t('report_expand_pages')}
                                    state={Array.from(reportStore.openPages.values()).every((isOpen) => isOpen)}
                                    onToggle={reportStore.toggleAllPages}
                                />
                            </div>
                            <div className="locales">
                                <Select
                                    options={survey.metadata.locales.map((locale) => ({
                                        value: locale,
                                        label: '',
                                        src: `${process.env.CDN_URL}/includes/images/flags/${locale}.png`,
                                    }))}
                                    defaultValue={reportStore.locale}
                                    onBlur={({ value }) => { reportStore.locale = value }}
                                />
                            </div>
                            {!isMaxbiReport
                                ? (
                                    <Button
                                        label={i18n.t('report_comparison')}
                                        icon="fa-light fa-filter-list"
                                        cssClass="regular tertiary"
                                        onClick={() => {
                                            reportStore.showComparison = !showComparison
                                        }}
                                    />
                                )
                                : null }
                        </div>
                        <ComparisonModal
                            reportStore={reportStore}
                            showComparisonSelector={showComparison}
                            toggleComparisonSelector={() => {
                                reportStore.showComparison = !showComparison
                            }}
                        />
                    </div>
                </PanelHeader>
            </Panel>
        )
    }
}

export default ReportHeader
